<script>
import { mapStores } from "pinia";

import IrregularVerbsService, { SUPPORTED_LANGUAGES } from "@/common/api/irregular-verbs.service";
import { addPackageAndLangParams } from "@/common/route-path-helpers";
import ContentCard from "@/components/ContentCard.vue";
import IrregularVerbsAccordion from "@/components/workshop/IrregularVerbsAccordion.vue";
import IrregularVerbsTable from "@/components/workshop/IrregularVerbsTable.vue";
import { useSettingsStore } from "@/stores";

/**
 * @readonly
 * @enum {string}
 */
const StateEnum = {
  Idle: "idle",
  Loading: "loading",
  Loaded: "loaded",
  Failed: "failed"
};

export default {
  name: "IrregularVerbsView",
  components: {
    ContentCard,
    IrregularVerbsAccordion,
    IrregularVerbsTable
  },
  data() {
    return {
      state: StateEnum.Idle,
      data: null
    };
  },
  computed: {
    ...mapStores(useSettingsStore),

    language() {
      return this.settingsStore.activeLanguageGroup;
    },
    isLoading() {
      return this.state === StateEnum.Loading;
    },
    isLoaded() {
      return this.state === StateEnum.Loaded;
    },
    hasFailed() {
      return this.state === StateEnum.Failed;
    }
  },
  watch: {
    language: {
      immediate: true,
      handler: function (language) {
        if (!SUPPORTED_LANGUAGES.includes(language)) {
          this.$router.push(addPackageAndLangParams({ name: "workshop" }));
          return;
        }
        this.fetch(language);
      }
    }
  },
  methods: {
    async fetch(language) {
      if (this.isLoading) {
        return;
      }

      this.state = StateEnum.Loading;

      try {
        this.data = await IrregularVerbsService.fetch(language);
        this.state = StateEnum.Loaded;
      } catch (e) {
        this.state = StateEnum.Failed;
      }
    }
  }
};
</script>

<template>
  <div class="irregular-verbs mb-5">
    <div class="container p-0">
      <div class="irregular-verbs__header">
        <div class="row">
          <div class="col">
            <h1 class="irregular-verbs__title">
              {{ $t("workshop.irregularVerbs.headline") }}
            </h1>
          </div>
        </div>
      </div>
      <main>
        <ContentCard class="irregular-verbs__content">
          <template v-if="isLoading">
            {{ $t("general.loading") }}
          </template>
          <template v-else-if="isLoaded">
            <IrregularVerbsAccordion class="d-block d-md-none" :items="data" />
            <IrregularVerbsTable class="d-none d-md-block" :items="data" />
          </template>
          <template v-else-if="hasFailed">
            {{ $t("general.loadingFailed") }}
          </template>
        </ContentCard>
      </main>
    </div>
  </div>
</template>
